'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useEffect, useState } from 'react';
import TransferModal from '../modals/TransferModal';
import AvatarSelectorModal from '../modals/AvatarSelectorModal';
import { copyTextToClipboard } from '@tma.js/sdk';
import clsx from 'clsx';
import { useClient, useQuery } from 'urql';
import { Me } from '@/graphql/queries';
import type { MeQuery, MeQueryVariables } from '@/gql/graphql';
import TopBirdsModal from '@/components/modals/TopBirdsModal';
import { PAGE_SIZE, useInfiniteList } from '@/hooks/useInfiniteList';
import { formatAmount } from '@/utils/helpers';
const leagueBadgeClasses: Record<string, string> = {
  Nestling: 'bg-gradient-to-r from-nestling/50 to-nestling text-foreground',
  Junior: 'bg-gradient-to-r from-junior/50 to-junior text-foreground',
  Master: 'bg-gradient-to-r from-master/50 to-master text-foreground',
  Expert: 'bg-gradient-to-r from-expert/50 to-expert text-foreground',
  Pro: 'bg-gradient-to-r from-pro/50 to-pro text-foreground',
  Plus: 'bg-gradient-to-r from-plus/50 to-plus text-foreground',
  Bronze: 'bg-gradient-to-r from-bronze/50 to-bronze text-foreground',
  Silver: 'bg-gradient-to-r from-silver/50 to-silver text-foreground',
  Gold: 'bg-gradient-to-r from-gold/50 to-gold text-foreground',
  Platinum: 'bg-gradient-to-r from-platinum/50 to-platinum text-foreground',
  Diamond: 'bg-gradient-to-r from-diamond/50 to-diamond text-foreground',
  Premium: 'bg-gradient-to-r from-premium/50 to-premium text-foreground',
  Feathered: 'bg-gradient-to-r from-feathered/50 to-feathered text-foreground'
} as const;
export default function NestTab() {
  const $ = _c(108);
  const [showAvatar, setShowAvatar] = useState(false);
  const [showTransfer, setShowTransfer] = useState(false);
  const [showTopBirds, setShowTopBirds] = useState(false);
  const client = useClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      pagination: {
        limit: PAGE_SIZE,
        offset: 0
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      query: Me,
      variables: t0 satisfies MeQueryVariables
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [meResult] = useQuery(t1);
  const me = meResult.data.me;
  let t2;
  if ($[2] !== me.language || $[3] !== me.wallet.balance) {
    t2 = me.wallet.balance.toLocaleString(me.language ?? "en", {
      maximumFractionDigits: 9,
      roundingMode: "ceil"
    });
    $[2] = me.language;
    $[3] = me.wallet.balance;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const balance = t2;
  let t3;
  if ($[5] !== client) {
    t3 = {
      client,
      query: Me,
      variablesFn: _temp,
      getItems: _temp2
    };
    $[5] = client;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    items: transactions,
    isLoadingMore,
    hasMore,
    scrollRef,
    sentinelRef,
    reset
  } = useInfiniteList(t3);
  let t4;
  if ($[7] !== meResult.data.me?.wallet?.transactions || $[8] !== reset) {
    t4 = () => {
      const fresh = meResult.data?.me?.wallet?.transactions;
      if (fresh) {
        reset(fresh);
      }
    };
    $[7] = meResult.data.me?.wallet?.transactions;
    $[8] = reset;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = meResult.data?.me?.wallet?.transactions;
  let t6;
  if ($[10] !== reset || $[11] !== t5) {
    t6 = [t5, reset];
    $[10] = reset;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t4, t6);
  const t7 = me.premium && "bg-linear-to-t from-transparent from-80% to-gold/50";
  let t8;
  if ($[13] !== t7) {
    t8 = clsx("pt-24", t7);
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setShowAvatar(true);
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== me.premium) {
    t10 = me.premium && <div className="absolute inset-0 z-25 rounded-full bg-linear-to-b from-transparent to-gold/50 animate-pulse" />;
    $[16] = me.premium;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== me.avatar) {
    t11 = me.avatar?.toLowerCase();
    $[18] = me.avatar;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = `/avatars/${t11}.png`;
  let t13;
  if ($[20] !== t12) {
    t13 = <Image src={t12} alt="Avatar" fill={true} className="object-contain p-4 z-50" />;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t10 || $[23] !== t13) {
    t14 = <div className="relative pt-8 flex justify-center bg-background rounded-t-4xl"><button onClick={t9} className="relative size-36 rounded-full border-3 border-primary/75 shadow-2xl">{t10}{t13}</button></div>;
    $[22] = t10;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== me.username) {
    t15 = <span className="text-center text-xl font-thin">@{me.username}</span>;
    $[25] = me.username;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== me.firstName || $[28] !== me.lastName || $[29] !== me.username || $[30] !== me.uuid) {
    t16 = () => copyTextToClipboard(`Bird: ${me.firstName} ${me.lastName}\nUUID: ${me.uuid}\nUsername: ${me.username}`);
    $[27] = me.firstName;
    $[28] = me.lastName;
    $[29] = me.username;
    $[30] = me.uuid;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Image src="/icon-copy.svg" alt="Copy username" width={24} height={24} />;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16) {
    t18 = <button onClick={t16}>{t17}</button>;
    $[33] = t16;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <button onClick={_temp3}><Image src="/icon-share.svg" alt="Share username & uuid" width={24} height={24} /></button>;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t15 || $[37] !== t18) {
    t20 = <div className="flex items-center justify-center gap-3 mt-6 mx-8">{t15}{t18}{t19}</div>;
    $[36] = t15;
    $[37] = t18;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== me.firstName || $[40] !== me.lastName) {
    t21 = <h3 className="text-center text-2xl mt-1">{me.firstName} {me.lastName}</h3>;
    $[39] = me.firstName;
    $[40] = me.lastName;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => setShowTopBirds(true);
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  const t23 = leagueBadgeClasses[me.league];
  let t24;
  if ($[43] !== t23) {
    t24 = clsx("px-8 py-2 text-lg font-semibold rounded-full transition-transform active:scale-95", t23);
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== me.league || $[46] !== t24) {
    t25 = <div className="flex justify-center mt-4"><button onClick={t22} className={t24}>{me.league} League</button></div>;
    $[45] = me.league;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <Image src="/feather.png" alt="Feather" width={48} height={48} />;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  const t27 = balance.length > 5 ? balance.length > 10 ? "text-xl" : "text-3xl" : "text-6xl";
  let t28;
  if ($[49] !== t27) {
    t28 = clsx("font-bold", t27);
    $[49] = t27;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== balance || $[52] !== t28) {
    t29 = <span className={t28}>{balance}</span>;
    $[51] = balance;
    $[52] = t28;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <span className="text-4xl text-primary">FTH</span>;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== t29) {
    t31 = <div className="mt-6 mx-6 p-8 flex items-center justify-center gap-4">{t26}{t29}{t30}</div>;
    $[55] = t29;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="px-6 mt-6"><button onClick={() => setShowTransfer(true)} className="w-full rounded-full bg-linear-to-r from-primary to-secondary py-6 text-2xl font-semibold shadow-xl">Transfer Feathers</button></div>;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  let t33;
  if ($[58] !== t14 || $[59] !== t20 || $[60] !== t21 || $[61] !== t25 || $[62] !== t31 || $[63] !== t8) {
    t33 = <div className={t8}>{t14}{t20}{t21}{t25}{t31}{t32}</div>;
    $[58] = t14;
    $[59] = t20;
    $[60] = t21;
    $[61] = t25;
    $[62] = t31;
    $[63] = t8;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <h3 className="text-xl font-semibold text-center mb-4">Goals</h3>;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== me.goals) {
    t35 = me.goals.map(_temp4);
    $[66] = me.goals;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  let t36;
  if ($[68] !== t35) {
    t36 = <div className="mt-10">{t34}<div className="space-y-3">{t35}</div></div>;
    $[68] = t35;
    $[69] = t36;
  } else {
    t36 = $[69];
  }
  let t37;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <h3 className="text-xl font-semibold text-center mb-4">Transactions</h3>;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  let t38;
  if ($[71] !== me.language || $[72] !== transactions) {
    let t39;
    if ($[74] !== me.language) {
      t39 = tx => <div key={tx.uuid} className="flex justify-between items-center bg-surface rounded-2xl p-4"><div className="flex-auto"><p className={clsx("font-medium", !tx.wallet && tx.txType === "mint" && "text-success", !tx.wallet && tx.txType === "burn" && "text-error")}>{tx.bird ?? tx.birdUuid ?? tx.wallet ?? tx.txType.toUpperCase()}</p><p className="text-xs text-muted">{new Date(tx.timestamp as string).toLocaleString(me.language ?? "en")}</p></div><div className={clsx("shrink-0 grow font-semibold text-end", tx.txType === "mint" || tx.txType === "debit" ? "text-success" : "text-error")}>{tx.txType === "mint" || tx.txType === "debit" ? "+" : "-"}{formatAmount(tx.amount, me.language)} FTH {tx.txType === "mint" ? " \uD83D\uDCB5" : tx.txType === "burn" ? " \uD83D\uDD25" : ""}</div></div>;
      $[74] = me.language;
      $[75] = t39;
    } else {
      t39 = $[75];
    }
    t38 = transactions.map(t39);
    $[71] = me.language;
    $[72] = transactions;
    $[73] = t38;
  } else {
    t38 = $[73];
  }
  let t39;
  if ($[76] !== isLoadingMore) {
    t39 = isLoadingMore && <div className="flex justify-center py-8"><span className="text-muted animate-pulse">Loading more transactions...</span></div>;
    $[76] = isLoadingMore;
    $[77] = t39;
  } else {
    t39 = $[77];
  }
  let t40;
  if ($[78] !== hasMore || $[79] !== sentinelRef) {
    t40 = hasMore && <div ref={sentinelRef} className="h-8" />;
    $[78] = hasMore;
    $[79] = sentinelRef;
    $[80] = t40;
  } else {
    t40 = $[80];
  }
  let t41;
  if ($[81] !== t38 || $[82] !== t39 || $[83] !== t40) {
    t41 = <div className="my-10">{t37}<div className="space-y-3">{t38}{t39}{t40}</div></div>;
    $[81] = t38;
    $[82] = t39;
    $[83] = t40;
    $[84] = t41;
  } else {
    t41 = $[84];
  }
  let t42;
  if ($[85] !== scrollRef || $[86] !== t36 || $[87] !== t41) {
    t42 = <div ref={scrollRef} className="flex-1 overflow-auto px-6 pb-24">{t36}{t41}</div>;
    $[85] = scrollRef;
    $[86] = t36;
    $[87] = t41;
    $[88] = t42;
  } else {
    t42 = $[88];
  }
  let t43;
  if ($[89] !== t33 || $[90] !== t42) {
    t43 = <div className="min-h-screen flex flex-col">{t33}{t42}</div>;
    $[89] = t33;
    $[90] = t42;
    $[91] = t43;
  } else {
    t43 = $[91];
  }
  let t44;
  if ($[92] !== me.avatar || $[93] !== showAvatar) {
    t44 = showAvatar && <AvatarSelectorModal current={me.avatar} onSelect={() => setShowAvatar(false)} />;
    $[92] = me.avatar;
    $[93] = showAvatar;
    $[94] = t44;
  } else {
    t44 = $[94];
  }
  let t45;
  if ($[95] !== me.language || $[96] !== me.username || $[97] !== me.uuid || $[98] !== me.wallet.balance || $[99] !== showTransfer) {
    t45 = showTransfer && <TransferModal uuid={me.uuid} username={me.username} balance={me.wallet.balance} language={me.language} onClose={() => setShowTransfer(false)} />;
    $[95] = me.language;
    $[96] = me.username;
    $[97] = me.uuid;
    $[98] = me.wallet.balance;
    $[99] = showTransfer;
    $[100] = t45;
  } else {
    t45 = $[100];
  }
  let t46;
  if ($[101] !== showTopBirds) {
    t46 = showTopBirds && <TopBirdsModal onClose={() => setShowTopBirds(false)} />;
    $[101] = showTopBirds;
    $[102] = t46;
  } else {
    t46 = $[102];
  }
  let t47;
  if ($[103] !== t43 || $[104] !== t44 || $[105] !== t45 || $[106] !== t46) {
    t47 = <>{t43}{t44}{t45}{t46}</>;
    $[103] = t43;
    $[104] = t44;
    $[105] = t45;
    $[106] = t46;
    $[107] = t47;
  } else {
    t47 = $[107];
  }
  return t47;
}
function _temp4(goal) {
  return <div key={goal.name} className="flex items-center bg-surface rounded-2xl px-6 py-4"><span className="text-xl font-bold">{goal.name}</span><span className="text-muted pl-4">{goal.description}</span></div>;
}
function _temp3() {}
function _temp2(data) {
  return data?.me?.wallet?.transactions ?? [];
}
function _temp(offset) {
  return {
    pagination: {
      limit: PAGE_SIZE,
      offset
    }
  } satisfies MeQueryVariables;
}